"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  PrMinBdDays: 'Compensation and benefits management',
  Basicdatasettings: 'Basic data settings',
  serviceperiodstandardsetting: 'Service period standard setting',
  PrMinBdDaysColumn: {
    no: 'serial number',
    stddesc: 'standard name',
    ownername: 'shipowner',
    stdyear: 'years',
    currency: 'currency',
    stdamt: 'amount',
    stoped: 'Whether to disable',
    startfrom: 'start date',
    endwith: 'end date',
    appstatus: 'state',
    remark: 'Remark',
    stdid: 'configure',
    dutyname: 'job title',
    jobclassname: 'grade',
    remark2: 'remark',
    stddays: 'months',
    stdyear2: 'effective year',
    timeoutsetting: 'timeout setting',
    authid: 'Salary preparation',
    yes: 'yes',
    noo: 'no',
    formt: 'Format202205',
    approval: 'approval',
    pending: 'Pending',
    loggedout: 'logged out',
    cmt: 'whether to submit',
    tosubmit: 'submitted',
    nosubmit: 'pending submission'
  },
  PrMinBdDaystTips: {
    add: 'add',
    del: 'delete',
    edit: 'edit',
    print: 'print',
    table: 'table',
    stamp: 'stamp',
    tips: 'tips',
    save: 'save',
    submit: 'submit',
    rollback: 'rollback',
    Select: 'Select',
    fullscreen: 'fullscreen',
    reduction: 'reduction',
    close: 'close',
    ApproveInformation: 'Approve Information',
    inputperson: 'inputperson',
    editor: 'editor',
    SubmissionApprovalStatus: 'Submission Approval Status',
    commitstatus: 'commit Status',
    creationtime: 'creation Time',
    Changethetime: 'Change The Time',
    Submitter: 'Submitter',
    submissiontime: 'Submission Time',
    delSure: 'Are you sure you want to delete the record?',
    confirm: 'confirm',
    cancel: 'cancel',
    insert: 'insert',
    delSuccess: 'successfully deleted!',
    delFailed: 'failed to delete!',
    saveSuccess: 'Successfully saved!',
    saveFailed: 'Save failed!',
    selectOneData: 'Please select at least one piece of data',
    message1: 'Standard name cannot be empty. please enter!',
    message2: 'Year and month cannot be empty. please enter!',
    message3: 'The year and month are entered incorrectly, the year should be a 6-digit integer, please re-enter!',
    message4: 'Payroll cannot be empty. please enter!',
    message5: 'Shipowner cannot be empty. please enter!',
    message6: 'Amount cannot be empty. please enter!',
    message7: 'The number of months cannot be empty. please enter!',
    message8: 'Start date cannot be later than end date!',
    message9: 'Submitted data cannot be deleted!',
    message10: 'Please select the row that needs to be deleted!',
    message11: 'Title is empty, please enter!',
    message12: 'Level is empty, please enter!',
    message13: 'Your changes may not be saved!',
    message14: 'close the window',
    message15: 'Add at least one detail',
    message16: 'The level of the same job cannot be repeated'
  }
};